import React, { useEffect, useState } from "react";
import { ThreeDots } from 'react-loader-spinner';
import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";
import { toast } from 'react-toastify';
import Modal from '../components/Modal/Modal';
import { FaEllipsisV, FaEdit, FaTrash } from 'react-icons/fa';
import { PiHandWithdrawFill } from "react-icons/pi";
import { GiExpense } from "react-icons/gi";
import { PiHandDepositFill } from "react-icons/pi";
import ConfirmationModal from "../components/Modal/ConfirmationModal";
import dayjs from "dayjs";


const formatCurrency = (val) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    }).format(Number(val));

function getTypeBadge(type) {
    switch (type) {
        case "Deposit":
            return (
                <span className="bg-green-900 text-green-400 px-3 py-1 rounded-full text-xs font-semibold ml-2">
                    Deposit
                </span>
            );
        case "Withdrawal":
            return (
                <span className="bg-red-900 text-red-400 px-3 py-1 rounded-full text-xs font-semibold ml-2">
                    Withdrawal
                </span>
            );
        case "Expense":
            return (
                <span className="bg-yellow-900 text-yellow-300 px-3 py-1 rounded-full text-xs font-semibold ml-2">
                    Expense
                </span>
            );
        default:
            return null;
    }
}

function getTypeIcon(type) {
    switch (type) {
        case "Deposit":
            return <span className="text-green-400 text-lg mr-1"><PiHandDepositFill/></span>;
        case "Withdrawal":
            return <span className="text-red-400 mr-1 text-lg "><PiHandWithdrawFill/></span>;
        case "Expense":
            return <span className="text-yellow-300 text-lg mr-1"><GiExpense/></span>;
        default:
            return null;
    }
}

function Transactions() {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [mode, setMode] = useState("create");
    const [transactionTypes, setTransactionTypes] = useState([]);
    const [data, setData] = useState({
        id: "",
        transactionDate: "",
        amount: "",
        type: "",
        description: "",
    })

    // Fetch data from API
    const fetchBankRoll = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(
                `${API_ENDPOINTS.BANKROLL}`
            );
            setTransactions(response.data.data);
            setLoading(false);
        } catch (err) {
            console.error("API error:", err);
            toast.error(err?.response?.data?.error || "Error fetching data");
            setLoading(false);
        }
    };

        useEffect(() => {
        const fetchLocationType = async () => {
            try {
                const response = await axiosInstance.get(`${API_ENDPOINTS.SELECTSCHEMA}`);
                setTransactionTypes(response.data.transactionTypes);
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to fetch game types");
            }
        };
        // Fetch game types when the component mounts
        fetchLocationType();
    }, []);

    useEffect(() => {
        fetchBankRoll();
    }, []);

    const handleOpenCreate = () => {
        setData({
            id: "",
            transactionDate: "",
            amount: "",
            type: "",
            description: "",
        });
        setMode("create");
        setModalOpen(true);
    };

    const handleOpenEdit = (trx) => {
        setData(trx);
        setMode("edit");
        setModalOpen(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        const formData = {
            transactionDate:  dayjs(data.transactionDate).format("YYYY-MM-DD"),
            amount: data.amount,
            type: data.type,
            description: data.description,
        }
        setLoading(true);
        try {
            if (mode === "create") {
                await axiosInstance.post(`${API_ENDPOINTS.BANKROLL}`, formData);
                toast.success("Transaction created successfully");
            } else {
                await axiosInstance.patch(`${API_ENDPOINTS.BANKROLL}`, {
                    id: data.id,
                    ...formData,
                });
                toast.success("Transaction updated successfully");
            }
            setModalOpen(false);
            setLoading(false);
            fetchBankRoll()

        } catch (error) {
            toast.error(error.response?.data?.error || "Something went wrong");
            setLoading(false);
        }
    };

    const handleDeleteModal = (trx) => {
        setMode('delete')
        setData(trx);
        setShowModal(true);
    }

     const handleDelete = async () => {
        setLoading(true);
        try {
            await axiosInstance.delete(`${API_ENDPOINTS.BANKROLL}?id=${data.id}`);
            toast.success("Transaction deleted successfully");
            setShowModal(false);
            fetchBankRoll();
        } catch (error) {
            toast.error(error.response?.data?.error || "Something went wrong");
        } finally {
            setLoading(false);
        }
    }


    const handleCancel = () => {
        setModalOpen(false);
        setShowModal(false);
        setData({
            id: "",
            transactionDate: "",
            amount: "",
            type: "",
            description: "",
        });
    }

 

    return (
        <div className="min-h-screen bg-black text-white px-8 py-6">
            {loading &&
                <ThreeDots
                    visible={true}
                    height="80"
                    width="80"
                    color="#1976d2"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass="dots-loading additional-class"
                />
            }
            <div className="flex md:justify-between flex-col md:flex-row md:items-center mb-6">
                <h1 className="text-3xl font-bold">Transactions</h1>
                <button
                    className="bg-secondary mt-5 md:mt-0 justify-center   hover:opacity-75 px-4 py-2 rounded text-white flex items-center gap-2  "
                    onClick={handleOpenCreate} // Add functionality can be implemented here
                >
                    + Add Transaction
                </button>
            </div>

            <div className=" overflow-x-auto text-nowrap ">
                <table className="w-full text-sm text-left text-white border border-border">
                    <thead className="bg-black border-b border-border">
                        <tr>
                            <th className="p-3">Date</th>
                            <th className="p-3">Amount</th>
                            <th className="p-3">Type</th>
                            <th className="p-3">Description</th>
                            <th className="p-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.map((tx) => (
                            <tr
                                key={tx.id}
                                className="border-b border-[#222] hover:bg-[#181818] transition"
                            >
                                <td className="py-4 px-3 font-medium">
                                    {dayjs(tx.transactionDate).format('D MMMM YYYY')}
                                </td>
                                <td
                                    className={`py-4 px-3 font-semibold ${tx.type !== 'Deposit' ? "text-red-500" : "text-green-500"
                                        }`}
                                >
                                    {tx.type !== "Deposit"
                                        ? "-" + formatCurrency(Math.abs(tx.amount))
                                        : formatCurrency(tx.amount)}
                                </td>
                                <td className="py-4 px-3 flex items-center">
                                    {getTypeIcon(tx.type)}
                                    {getTypeBadge(tx.type)}
                                </td>
                                <td className="py-4 px-3">{tx.description}</td>
                                <td className="px-4 py-5 text-right relative">
                                    <button
                                        onClick={() => setOpenMenuIndex(openMenuIndex === tx.id ? null : tx.id)}
                                        className="text-gray-400 hover:text-white"
                                    >
                                        <FaEllipsisV />
                                    </button>

                                    {openMenuIndex === tx.id && (
                                        <div className="absolute right-6 bottom-0 mr-2 p-1 mt-2 w-32 bg-zinc-800 border border-zinc-700 rounded shadow-lg z-10">
                                            <button
                                                onClick={() => handleOpenEdit(tx)}
                                                className="flex items-center gap-2 px-4 py-2 hover:bg-zinc-700 w-full text-left text-sm"
                                            >
                                                <FaEdit className="text-white" />
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => handleDeleteModal(tx)}
                                                className="flex items-center gap-2 px-4 py-2 hover:bg-zinc-700 w-full text-left text-sm text-red-400"
                                            >
                                                <FaTrash />
                                                Delete
                                            </button>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))}
                        {transactions.length === 0 && (
                            <tr>
                                <td colSpan={5} className="py-6 text-center text-gray-500">
                                    No transactions found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Modal
                isOpen={modalOpen}
                onClose={handleCancel}
                data={data}
                onChange={handleChange}
                onSave={handleSave}
                mode={mode}
                title={mode === "create" ? "Add New Transaction" : "Edit Transaction"}
                type="Bankroll"
                typeOptions={transactionTypes}

            />
            <ConfirmationModal
                open={showModal}
                title="Are you sure?"
                message={`
                        This will permanently delete the ${data.type} of $${data.amount} on ${data.transactionDate} This action cannot be undone
                `}
                onCancel={handleCancel}
                onConfirm={handleDelete}
            />
        </div>
    );
}

export default Transactions;